import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OrderItemUpdateModalUI from './OrderItemUpdateModalUI.js'

class OrderItemUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      // update order item
      submitted: false,
      // item name
      itemName: '',
      // quantity
      quantity: '',
      quantityError: null,
      // price
      price: '',
      priceError: null,
      // due date
      dueDate: '',
      dueDateError: null
    }
  }

  render() {
    return (
      <OrderItemUpdateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // update mode
        updateMode={this.props.updateMode}
        // item name
        itemName={this.state.itemName}
        // quantity
        quantity={this.state.quantity}
        onQuantityChange={(event) => { this.setState({ quantity: event.target.value }) }}
        quantityError={this.state.quantityError}
        setQuantityError={(event) => { this.setState({ quantityError: event.target.value }) }}
        // price
        price={this.state.price}
        onPriceChange={(event) => { this.setState({ price: event.target.value }) }}
        priceError={this.state.priceError}
        setPriceError={(event) => { this.setState({ priceError: event.target.value }) }}
        // due date
        dueDate={this.state.dueDate}
        onDueDateChange={(selectedDateISO) => {
          this.setState({ dueDate: selectedDateISO })
        }}
        dueDateError={this.state.dueDateError}
        setDueDateError={(event) => { this.setState({ dueDateError: event.target.value }) }}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
    console.log("component mount")
  }

  componentDidUpdate(prevProps) {
    console.log("component update")
    console.log(this.props)
    if (this.props.orderItem && (!prevProps.orderItem || prevProps.orderItem && this.props.orderItem.orderItemId !== prevProps.orderItem.orderItemId)) {
      this.setState({
        itemName: this.props.orderItem.itemName,
        quantity: this.props.orderItem.quantity,
        price: this.props.orderItem.priceF,
        dueDate: this.props.orderItem.dueDate
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/orderItems/${this.props.orderItem.orderItemId}`,
      this.onSubmitCallback, {
      quantity: this.state.quantity,
      priceF: this.state.price,
      dueDate: this.state.dueDate
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'quantity':
          this.setState({ quantityError: error.message })
          break;
        case 'priceF':
          this.setState({ priceError: error.message })
          break;
        case 'dueDate':
          this.setState({ dueDateError: error.message })
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
      }, 2000)
      this.props.onUpdateComplete(response.orderItem, response.customerOrder)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      quantityError: null,
      priceError: null,
      dueDateError: null,
      submitted: false
    })
    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_update_order_item',
      'c_product',
      'c_update',
      'c_cancel',
      'c_quantity',
      'c_price',
      'c_due_date'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('ord_itm_upd', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }

}

export default withRouter(OrderItemUpdateModalSF)
